import React from 'react';
import { StyleSheet, View } from 'react-native';

import { leagueConfigSelector, useLeagueConfigsStore } from '@/feature/betslip-pickem/hooks/use-league-configs-store';
import { withOpacity } from '@/styles/styles';
import { League } from '@/types/api.generated';
import { useShallow } from 'zustand/react/shallow';

const PLAYER_HEIGHT = 68;

const alignmentToStyleMap = {
    left: {
        left: -40,
        top: 0,
        transform: [{ rotate: '0deg' }],
    },
    right: {
        right: -40,
        bottom: 0,
        transform: [{ rotate: '180deg' }],
    },
};

export const UfcGradient = ({ alignment = 'left' }: { alignment?: 'left' | 'right' }) => {
    const { leagueColor } = useLeagueConfigsStore(useShallow(leagueConfigSelector(League.Ufc)));

    return (
        <View
            style={[
                styles.gradient,
                alignmentToStyleMap[alignment],
                { backgroundColor: withOpacity(leagueColor, 0.3) },
            ]}
        />
    );
};

const styles = StyleSheet.create({
    gradient: {
        width: '15%',
        height: PLAYER_HEIGHT,
        position: 'absolute',
        borderRadius: PLAYER_HEIGHT / 2,
        filter: 'blur(55px)',
    },
});
